import React, { ChangeEvent } from 'react';
import { Typography } from '../Typography/Typography';
import { UseFormRegisterReturn } from 'react-hook-form';

import styles from './Input.module.scss';
import classnames from 'classnames/bind';

const cx = classnames.bind(styles);

export interface ICommonProps {
  type: 'text' | 'number' | 'email' | 'time' | 'password';
  label: string;
  error?: string;
  helperText?: string;
  hasMargin?: boolean;
  placeholder?: string;
  rows?: number;
  disabled?: boolean;
}
export interface IControlled {
  register?: never;
  onChange: (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  id: string;
  value: string | number | undefined;
}

export interface IUncontrolled {
  register: UseFormRegisterReturn;
  onChange?: never;
  id?: never;
  value?: never;
}

export type TInputProps = ICommonProps & (IControlled | IUncontrolled);

export const Input = ({
  register,
  label,
  type,
  error,
  helperText,
  id,
  onChange,
  value,
  hasMargin = false,
  placeholder = ' ', // this allows the label to move when the input is not empty
  rows = 1,
  disabled = false,
}: TInputProps) => {
  const elementId = id ?? register?.name;

  return (
    <div
      className={cx('input-wrapper', {
        'margin-bottom': hasMargin,
      })}
    >
      {rows > 1 ? (
        <textarea
          className={cx('input', { 'error-border': error })}
          placeholder={placeholder}
          id={elementId}
          onChange={onChange}
          value={value}
          rows={rows}
          disabled={disabled}
          {...register}
        />
      ) : (
        <input
          className={cx('input', { 'error-border': error })}
          placeholder={placeholder}
          id={elementId}
          type={type}
          onChange={onChange}
          value={value}
          disabled={disabled}
          {...register}
        />
      )}
      <label className={cx('label', { 'error-color': error, 'move-label': placeholder !== ' ' })} htmlFor={elementId}>
        {label}
      </label>
      {error && (
        <Typography size="M" className={cx('error-msg', 'error-color')}>
          {error}
        </Typography>
      )}
      {!error && helperText && (
        <Typography size="M" className={cx('helper-text')}>
          {helperText}
        </Typography>
      )}
    </div>
  );
};

export default Input;
